/* eslint-disable import/prefer-default-export */
export const selectSubsidiaries = store => store.companySubsidiaries?.subsidiaries;
